<template>
  <div class="home">

    <!-- Claim -->
    <div class="claim">
      <div class="claim__content">
        <ClaimText
          :canAnimate="canAnimate"
          :delay="1500">
          <h1>
            <span class="title__word">
              <span class="title__chars">Di</span><span class="title__chars">g</span><span class="title__chars">i</span><span class="title__chars">ta</span><span class="title__chars">l</span>
            </span>
            <span class="title__word">
              <span class="title__chars">W</span><span class="title__chars">e</span><span class="title__chars">l</span><span class="title__chars">l</span>&nbsp;<span class="title__chars">do</span><span class="title__chars">n</span><span class="title__chars">e</span>
            </span>
          </h1>
        </ClaimText>
      </div>

      <!-- <ScrollIndicator
        v-if="isLoad"/> -->
    </div>
    <!-- ./Claim -->

    <!-- Animated Hero -->
    <HeaderImage
      v-if="canAnimate"
      :image="image[0]"
      :filter="filter[0]"
      :sizes="imageSrcSizes"
    />
    <!-- ./Animated Hero -->

    <!-- About Intro -->
    <div class="about">
      <div class="about__content">
        <AnimatedText>
          Hello, I am <strong>Davide Marchet</strong>, a web designer and developer based in Padua, Italy. I plan and build clean websites and applications, creating curated digital environments tailored to each client's unique vision. I am currently working at <a href="https://www.quamm.it" target="_blank" rel="noreferrer">Quamm web Agency</a>, where I have contributed to a variety of projects across several fields. These include  <a href="https://apps.apple.com/it/app/airness/id6447354554" target="_blank" rel="noreferrer">mobile apps</a>, <a href="https://www.airdom.com" target="_blank" rel="noreferrer">high-traffic ecommerce</a>, <a href="https://custom.airness.eu/" target="_blank" rel="noreferrer">3D product customization</a>, and an <a href="https://www.pixartprinting.it/blog/" target="_blank" rel="noreferrer">international blog</a>. I have also worked on projects for <a href="https://zavaluce.it/it" target="_blank" rel="noreferrer">international design firms</a>, <a href="https://www.hotellagodigarda.it" target="_blank" rel="noreferrer">hotels</a>, <a href="https://www.propostavini.com/" target="_blank" rel="noreferrer">large-scale retail trade</a>, <a href="http://www.rossetto.work/" target="_blank" rel="noreferrer">service companies</a>, <a href="https://www.alebikewear.com/" target="_blank" rel="noreferrer">sports brands</a>, and <a href="https://www.gopleyers.com" target="_blank" rel="noreferrer">small business ecommerce</a>.
        </AnimatedText>
      </div>
    </div>
    <!-- About Intro -->
    <!-- Skills -->
    <AnimatedIntro>
      <h2>
        <span class="title__word">
          <span class="title__chars">Te</span><span class="title__chars">c</span><span class="title__chars">h</span><span class="title__chars">n</span><span class="title__chars">o</span><span class="title__chars">lo</span><span class="title__chars">g</span><span class="title__chars">i</span><span class="title__chars">es</span></span>
      </h2>
    </AnimatedIntro>

    <div class="section">
      <div class="section__content">
        <AnimatedText>I am a director-level designer and developer, capable of guiding the client from the groundwork to the fine-tuning of their project. I handle the intricacies of new technologies and current design trends, and deliver the perfect product for their online brand presence.</AnimatedText>
      </div>
    </div>

    <Grid />
    <!-- ./Skills -->

    <!-- I'm -->
    <div class="im">

      <PortraitImage
        v-if="canAnimate"
        :image="imageAbout[0]"
        :filter="filterAbout[0]"
        :sizes="imageAboutSrcSizes" />

      <AnimatedIntro class="intro__claim">
        <h2>
          <span class="title__word">
            <span class="title__chars">Be</span><span class="title__chars">h</span><span class="title__chars">i</span><span class="title__chars">nd</span>
          </span>
          <span class="title__word">
            <span class="title__chars">T</span><span class="title__chars">h</span><span class="title__chars">e</span>&nbsp;<span class="title__chars">co</span><span class="title__chars">d</span><span class="title__chars">e</span>
          </span>
        </h2>
      </AnimatedIntro>

      <!-- About Me -->
      <div class="about">
        <div class="about__content">
          <AnimatedText>
            I approach code, myself and life the way a brutalist builder would approach their creation: looking at implementing creative solutions using the best combination the materials at hand will allow me. When I manage to pry myself away from the computer display, I travel to <a href="https://www.instagram.com/calvertjournal/" target="_blank"  rel="noreferrer">New East</a> looking for interesting architecture such as <a href="https://www.instagram.com/spomenikdatabase/" target="_blank" rel="noreferrer">Spomeniks</a>, beautiful nature and any odd and interesting experiences in general. I appreciate music, electronic in particular, and I am part of the founding committee of a Music and Visual festival set in northern Italy called <a href="https://www.youtube.com/watch?v=uWvhrulsP7c" target="_blank"  rel="noreferrer">Fuochi Fatui</a>.
          </AnimatedText>
        </div>
      </div>
      <!-- About Me -->

    </div>
    <!-- ./I'm -->

    <!-- Contact -->
    <AnimatedIntro>
      <h2>
        <span class="title__word">
          <span class="title__chars">G</span><span class="title__chars">e</span><span class="title__chars">t</span>&nbsp;<span class="title__chars">in</span>&nbsp;<span class="title__chars">t</span><span class="title__chars">o</span><span class="title__chars">uc</span><span class="title__chars">h</span></span>
      </h2>
    </AnimatedIntro>

    <div class="section">
      <div class="about__content contact">
        <AnimatedText>
          <a href="mailto:info@davidemarchet.com">info@davidemarchet.com</a><br/>
          <a href="https://github.com/DidoMarchet" target="_blank" rel="noreferrer">Github /DidoMarchet</a><br/>
          <a href="https://twitter.com/didomarket" target="_blank" rel="noreferrer">Twitter @didomarket</a><br/>
          <a href="https://www.linkedin.com/in/davide-marchet-2b185333/" target="_blank" rel="noreferrer">Linkedin</a><br/>
          <a href="/assets/pdf/davide-marchet-web-desginer-developer.pdf" target="_blank" rel="noreferrer">Resume (Cv)</a><br/>
        </AnimatedText>
      </div>
      <div class="section__content credit">
        <AnimatedText>
          Photography curated by <br/> <a href="http://www.atipicaphotography.com/" target="_blank" rel="noreferrer">Atipica Photography</a>
        </AnimatedText>
      </div>
    </div>

    <!-- ./Contact -->

  </div>
</template>

<script>
import HeaderImage from '@/components/HeaderImage/HeaderImage.vue'
import ClaimText from '@/components/ClaimText/ClaimText.vue'
import AnimatedText from '@/components/AnimatedText/AnimatedText.vue'
import AnimatedIntro from '@/components/AnimatedIntro/AnimatedIntro.vue'
import Grid from '@/components/Grid/Grid.vue'
import PortraitImage from '@/components/PortraitImage/PortraitImage.vue'

export default {
  name: 'Home',
  components: {
    HeaderImage,
    ClaimText,
    AnimatedText,
    AnimatedIntro,
    Grid,
    PortraitImage
  },
  data: () => ({
    filterSrc: require('@/assets/img/ripple-texture.png'),
    image: undefined,
    filter: undefined,
    isLoad: false
  }),
  props: {
    canAnimate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    imageSrc: {
      get () {
        return window.matchMedia('(min-width: 1360px)').matches ? require('@/assets/img/davide-marchet-web-developer.jpg') : require('@/assets/img/davide-marchet-web-developer-low.jpg')
      }
    },
    imageAboutSrc: {
      get () {
        return window.matchMedia('(min-width: 1360px)').matches ? require('@/assets/img/davide-marchet-web-designer.jpg') : require('@/assets/img/davide-marchet-web-designer-low.jpg')
      }
    },
    imageSrcSizes: {
      get () {
        return window.matchMedia('(min-width: 1360px)').matches ? [1400, 2048] : [700, 1024]
      }
    },
    imageAboutSrcSizes: {
      get () {
        return window.matchMedia('(min-width: 1360px)').matches ? [1570, 2048] : [785, 1024]
      }
    },
    imageFilterSrc: {
      get () {
        return window.matchMedia('(min-width: 1360px)').matches ? require('@/assets/img/ripple-texture.jpg') : require('@/assets/img/ripple-texture-low.jpg')
      }
    },
    imageFilterAboutSrc: {
      get () {
        return window.matchMedia('(min-width: 1360px)').matches ? require('@/assets/img/ripple-texture-about.jpg') : require('@/assets/img/ripple-texture-about-low.jpg')
      }
    }
  },
  async mounted () {
    this.image = await this.$imageLoader(this.imageSrc)
    this.imageAbout = await this.$imageLoader(this.imageAboutSrc)
    this.filter = await this.$imageLoader(this.imageFilterSrc)
    this.filterAbout = await this.$imageLoader(this.imageFilterAboutSrc)
    this.isLoad = true
    this.$emit('isLoad')
  }
}
</script>

<style lang="scss">

@import './style.scss';

</style>
